import React, { useEffect } from 'react'
import { Button } from '@/ui'
import { api, useDigitalSign } from '@/shared'
import { userThunks } from '@/entity'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { toBase64Utf8 } from '@/utils'

export const Verification = ({ user, onSuccess }) => {
	const dispatch = useDispatch()
	const { t } = useTranslation()
	const { successPayload, onSign, onClearPayload } = useDigitalSign()

	useEffect(() => {
		if (successPayload) {
			const base64 = toBase64Utf8(successPayload)
			let body = {
				data: { xmlData: base64, id: user?.personDetails?.id },
				payload: {
					flEmployer: false,
				},
				onSuccess: () => {
					onSuccess()
				},
			}
			dispatch(userThunks.verification(body))
			onClearPayload()
		}
	}, [successPayload])
	const getUserXml = async () => {
		onSign(await api.profile.getXML())
	}
	return (
		<div>
			<Button onClick={() => getUserXml()}>{t('sign_ecp_rsa')}</Button>
		</div>
	)
}
